module.exports = __webpack_public_path__ + "static/media/importFlybook2.9b056e3a.png";